import React, { useEffect, useState } from "react";
import DataTable from "../../components/Comman/CustomTable/CommonTable";
import { useDispatch } from "react-redux";
import { submissionListStatusAction } from "../../actions/admin";
import { Tooltip, Form } from "antd";
import CategoryListing from "../../components/Comman/DropdownsListing/CategoryListing";

const SubmissionStatus = () => {
  const dispatch = useDispatch<any>();
  const [form] = Form.useForm();
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [dynamicColumns, setDynamicColumns] = useState<any[]>([]);
  const [selectedCatId, setSelectedCatId] = useState<number | null>(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const statusClassMap = {
    submitted: "submitted status-col",
    pending: "pending status-col",
    pastDue: "past-due status-col",
    resubmission: "resubmission status-col",
  };

  const fetchSubmissionData = (params = {}) => {
    setLoading(true);
    const payload = { params, id: selectedCatId };
    dispatch(
      submissionListStatusAction(payload, (resp: any) => {
        setLoading(false);
        if (resp?.status === 200) {
          setData(resp.data || []);

          const organizationMap = {};
          const organizationTooltipMap: Record<number, string> = {};
          const userNameMap: Record<number, string> = {};

          resp?.data?.[0]?.assignment?.forEach((item) => {
            const id = item?.organization?.id;
            organizationMap[id] = item?.organization?.shortCode;
            organizationTooltipMap[id] = item?.organization?.name; // Full name for tooltip
            userNameMap[id] = item?.data_user?.name || "N/A";
          });
          // Collect all unique organization IDs from the data
          const getUniqueOrgIds = () => {
            const orgIds = new Set();
            resp?.data.forEach((element) => {
              element.assignment.forEach((assignment) => {
                orgIds.add(assignment.organizationId);
              });
            });
            return Array.from(orgIds);
          };

          const uniqueOrgIds = getUniqueOrgIds();

          // Transform data for the table
          // const transformDataForTable = () => {
          //   return resp?.data?.map((element) => {
          //     // Create a base record with data element info
          //     const record = {
          //       key: element.id,
          //       dataElementName: element.DataElements_Name,
          //       description: element.DataElements_Description,
          //       isBudgeted: element.DataElements_IsBudgeted,
          //     };

          //     // Add organization submission status
          //     uniqueOrgIds.forEach((orgId) => {
          //       const assignment = element.assignment.find(
          //         (a) => a.organizationId === orgId
          //       );

          //       // console.log(assignment);
          //       record[`org_${orgId}`] = assignment ? (
          //         <div
          //           className={
          //             statusClassMap[
          //               assignment?.organization?.SubmissionData_Status
          //             ]
          //           }
          //         >
          //           {assignment?.organization?.SubmissionData_Status === null
          //             ? "-"
          //             : ""}
          //         </div>
          //       ) : (
          //         "-"
          //       );
          //       // record[`org_${orgId}`] = assignment
          //       //   ? assignment?.organization?.SubmissionData_Status ===
          //       //     "submitted"
          //       //     ? "Yes"
          //       //     : "No"
          //       //   : "N/A";
          //     });

          //     return record;
          //   });
          // };

          const transformDataForTable = () => {
            return resp?.data?.map((element) => {
              // Create a base record with data element info
              const record = {
                key: element.id,
                dataElementName: element.DataElements_Name,
                description: element.DataElements_Description,
                isBudgeted: element.DataElements_IsBudgeted,
              };

              // Add organization submission status
              uniqueOrgIds.forEach((orgId) => {
                const assignment = element.assignment.find(
                  (a) => a.organizationId === orgId
                );

                // Store both status component and user data
                record[`org_${orgId}`] = {
                  statusComponent: assignment ? (
                    <div
                      className={
                        statusClassMap[
                          assignment?.organization?.SubmissionData_Status
                        ]
                      }
                    >
                      {assignment?.organization?.SubmissionData_Status === null
                        ? "-"
                        : ""}
                    </div>
                  ) : (
                    "-"
                  ),
                  userName: assignment?.data_user?.name || "N/A",
                  status: assignment?.organization?.SubmissionData_Status,
                };
              });

              return record;
            });
          };

          const tableData = transformDataForTable();

          setData(tableData);
          const columns = [
            {
              title: "Data Element",
              dataIndex: "dataElementName",
              key: "dataElementName",
              fixed: "left",
              width: 120,
              render: (text) => <div>{text}</div>,
            },
            // ...uniqueOrgIds.map((orgId: number) => ({
            //   // title: organizationMap[orgId],
            //   title: (
            //     <Tooltip title={organizationTooltipMap[orgId]}>
            //       {organizationMap[orgId]}
            //     </Tooltip>
            //   ),
            //   dataIndex: `org_${orgId}`,
            //   key: `org_${orgId}`,
            //   width: 120,
            //   render: (text, record) => {
            //     console.log(record, "skdjfksdjf");
            //     let textColor = "text-gray-500";
            //     if (text === "Yes") textColor = "text-green-600";
            //     if (text === "No") textColor = "text-red-600";

            //     // return <div className={textColor}>{text}</div>;
            //     return (
            //       <Tooltip title={text}>
            //         <div className={textColor}>{text}</div>
            //       </Tooltip>
            //     );
            //   },
            // })),

            ...uniqueOrgIds.map((orgId: number) => ({
              title: (
                <Tooltip title={organizationTooltipMap[orgId]}>
                  {organizationMap[orgId]}
                </Tooltip>
              ),
              dataIndex: `org_${orgId}`,
              key: `org_${orgId}`,
              width: 120,
              render: (cellData, record) => {
                if (!cellData || cellData === "-") return "-";

                const { statusComponent, userName, status } = cellData;

                return (
                  // <Tooltip
                  //   title={
                  //     //   `Status: ${
                  //     //   status || "Not available"
                  //     // },
                  //     `${userName}`
                  //   }
                  // >
                  //   <div className="flex flex-col">
                  //     {statusComponent}
                  //     {/* <div className="text-xs mt-1 text-gray-600">
                  //       {userName}
                  //     </div> */}
                  //   </div>
                  // </Tooltip>
                  <div className="flex flex-col items-start">
                    <Tooltip title={userName}>
                      <div>{statusComponent}</div>
                    </Tooltip>
                  </div>
                );
              },
            })),
          ];
          setDynamicColumns(columns);
          setPagination({
            ...pagination,
            total: resp.pagination?.totalItems,
            current: resp.pagination?.currentPage,
            pageSize: resp.pagination?.pageSize,
          });
        }
      })
    );
  };

  useEffect(() => {
    fetchSubmissionData({
      page: pagination.current,
      limit: pagination.pageSize,
    });
  }, [pagination?.current, pagination?.pageSize, selectedCatId]);

  const handleTableChange = (newPagination: any) => {
    setPagination({
      ...pagination,
      current: newPagination?.current,
      pageSize: newPagination?.pageSize,
    });
  };

  const handlCategorySelect = (catId) => {
    setPagination({
      current: 1,
      pageSize: 10,
      total: 0,
    });
    setSelectedCatId(catId);
  };

  return (
    <div>
      {/* <Header /> */}
      <div className="flex flex-col sm:flex-row justify-between mt-[30px] mb-[20px]">
        <h2 className="text-[16px] 2xl:text-[18px] mb-[20px] sm:mb-0">
          Submission Status
        </h2>
        <div className="flex gap-3 items-center flex-wrap">
          <div className="flex gap-2 items-center">
            <span className="past-due status-col"></span>
            <p className="text-[12px] 2xl:tet-sm">PAST DUE</p>
          </div>
          <div className="flex gap-2 items-center">
            <span className="submitted status-col"></span>
            <p className="text-[12px] 2xl:tet-sm">SUBMITTED</p>
          </div>
          <div className="flex gap-2 items-center">
            <span className="pending status-col"></span>
            <p className="text-[12px] 2xl:tet-sm">PENDING</p>
          </div>
          <div className="flex gap-2 items-center">
            <span className="resubmission status-col"></span>
            <p className="text-[12px] 2xl:tet-sm">RESUBMISSION</p>
          </div>
        </div>
      </div>
      <Form form={form} layout="vertical">
        <div className="flex justify-between bg-primary p-[15px] rounded-[10px] items-center mb-3">
          <div className="flex gap-[45px] items-center">
            <div className="select-col flex gap-[10px] items-center select_space_controller">
              <p className="info-col">Select Category:</p>
              <CategoryListing onSelect={handlCategorySelect} />
            </div>
          </div>
        </div>
      </Form>
      <div className="table-col">
        <DataTable
          columns={dynamicColumns}
          data={data}
          loading={loading}
          rowKey="id"
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
          }}
          onTableChange={handleTableChange}
        />
      </div>
    </div>
  );
};

export default SubmissionStatus;
